<div class="container pt-5 px-lg-0">
	<div class="my-5">
		<div class="text-center mb-2">
			<h1 class="titolo-bertazzoni">COLOR ASSOCIATION</h1>
		</div>
		<div class="row">
			<div class="col-12">
				<!--LASCIARE ORDINAMENTO SOLO SU COLONNA CLIENTE AS400, LE SELECT DELLE ALTRE DUE COLONNE PARTONO DISABILITATE E IL BTN SALVA NASCOSTO. SI ATTIVA TUTTO AL CLICK SULLA MODIFICA-->
				<table datatable [dtOptions]="dtSettings" [dtTrigger]="dtTrigger" class="row-border hover">
					<thead>
						<tr>
							<th>ID PLM</th>
							<th>Translation</th>
							<th>Order</th>
							<th>Color</th>
							<th></th>
						</tr>
					</thead>
					<tbody *ngIf="colori.length > 0">
						<tr *ngFor="let colore of colori">
							<td>{{colore.idBertazzoni}}</td>
							<td translate>{{colore.idBertazzoni}}</td>
							<td>
								<div class="row" *ngIf="colore.feEdit">
									<input
										type="number"
										class="form-bertazzoni white  rounded-0"
										placeholder="Order"
										[(ngModel)]="colore.ordine"
										name="ordine" />
								</div>
								<div *ngIf="!colore.feEdit">
									{{colore.ordine}}
								</div>
							</td>
							<td>
								<div class="row" *ngIf="!colore.feEdit">
									<div class="cerchietto-2 mr-2" [style.background-color]="colore.codiceHtml"></div>
									<span>{{colore.codiceHtml}}</span>
								</div>

								<color-chrome
									*ngIf="colore.feEdit"
									color="{{colore.codiceHtml}}"
									(onChangeComplete)="colore.codiceHtml = $event.color.hex"></color-chrome>
							</td>
							<th>
								<button
									type="button"
									class="btn btn-bertazzoni black rounded-0"
									*ngIf="colore.feEdit"
									(click)="save(colore)"
									[disabled]="!colore.codiceHtml">
									SAVE
								</button>
								<img src="assets/img/pencil.svg" class="action-icon" *ngIf="!colore.feEdit" (click)="colore.feEdit = !colore.feEdit" />
							</th>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>
